import { defineStore } from 'pinia'

export const useCurrencyStore = defineStore({
  id: 'currency',
  state: () => ({
    currency: localStorage.getItem('user-currency') || 'xdr'
  })
})
